import { Box, Typography } from '@mui/material';
import React from 'react';
import { grey, success } from 'src/theme';

interface TextFieldJumboViewProps {
  icon?: React.ReactNode;
  label?: string;
  placeholder?: string;
  value?: string | null;
  onClick?: () => void;
}

export const TextFieldJumboView: React.FC<TextFieldJumboViewProps> = (props) => (
  <Box
    width="100%"
    onClick={props.onClick}
    sx={{
      background: grey[200],
      borderRadius: '50px',
      padding: { xs: '8px 14px', md: '12px 20px' },
      height: '70px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      cursor: 'pointer',
    }}
  >
    {props.icon && (
      <Box
        width="34px"
        height="34px"
        sx={{
          background: success.dark,
          borderRadius: '50px',
          display: 'flex',
          textAlign: 'center',
          alignItems: 'center',
          justifyContent: 'center',
          flexGrow: 0,
          flexShrink: 0,
        }}
      >
        {props.icon}
      </Box>
    )}
    <Box
      sx={{
        flexGrow: 1,
      }}
    >
      <div className="flex flex-col">
        {props.label && (
          <Typography variant="subtitle2" component="span">
            {props.label}
          </Typography>
        )}
        {props.value && (
          <Typography variant="subtitle1" component="span">
            {props.value}
          </Typography>
        )}
        {!props.value && (
          <Typography variant="subtitle1" component="span" color={grey[500]}>
            {props.placeholder}
          </Typography>
        )}
      </div>
    </Box>
  </Box>
);
